module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0033.fa022d0f.jpg";